import React from "react"
import styles from "./userNotPermission.module.css"
import { NavLink, useNavigate, useParams } from "react-router-dom"
import imageBlock from "../../images/block.png"
import { TbArrowBackUp, TbCreditCard, TbFileExport, TbHome, TbShieldLock } from "react-icons/tb"

const UserNotPermission = ({ blocked = false, paymentByPartner = false, permissions = {}, account_id }) => {
    const navigate = useNavigate()
    const params = useParams()
    const currentAccountId = account_id || params?.account_id

    return (
        <div className={styles.body}>
            {blocked &&
                <div className={styles.blockCard}>
                    <div className={styles.iconBadge}>
                        <TbShieldLock />
                    </div>
                    <div className={styles.copy}>
                        <span className={styles.eyebrow}>Licença expirada</span>
                        <h1>Renove a assinatura para voltar a usar a Oktto</h1>
                        <p>O acesso aos recursos principais está pausado até a renovação da assinatura. As informações da conta permanecem preservadas.</p>
                    </div>
                    {paymentByPartner &&
                        <div className={styles.notice}>Para reativar sua conta, entre em contato com o parceiro responsável pela licença.</div>
                    }
                    {!paymentByPartner && permissions?.finance > 0 &&
                        <div className={styles.actions}>
                            <NavLink className={styles.primaryAction} to={`/${account_id}/myaccount`}>
                                <TbCreditCard /> Renovar assinatura
                            </NavLink>
                        </div>
                    }
                    {permissions?.reports > 0 &&
                        <div className={styles.secondaryAction}>
                            <span>Seus dados estão a salvo.</span>
                            <NavLink to={`/${account_id}/reports`}>
                                <TbFileExport /> Exportar relatórios
                            </NavLink>
                        </div>
                    }
                    <img className={styles.blockImage} alt="Conta bloqueada" src={imageBlock} />
                </div>

            }
            {!blocked &&
                <div className={styles.permissionCard}>
                    <div className={styles.iconBadge}>
                        <TbShieldLock />
                    </div>
                    <div className={styles.copy}>
                        <span className={styles.eyebrow}>Acesso restrito</span>
                        <h1>Você não possui permissão de acesso a essa página</h1>
                        <p>Essa área exige uma permissão específica da conta. Caso precise acessar, solicite a liberação a um administrador.</p>
                    </div>
                    <div className={styles.actions}>
                        <button className={styles.secondaryButton} type="button" onClick={() => navigate(-1)}>
                            <TbArrowBackUp /> Voltar
                        </button>
                        <NavLink className={styles.primaryAction} to={currentAccountId ? `/${currentAccountId}` : "/"}>
                            <TbHome /> Início
                        </NavLink>
                    </div>
                    <img className={styles.blockImage} alt="" src={imageBlock} />
                </div>
            }
        </div>
    )
}

export default UserNotPermission
